import React, { Component } from 'react';
import Bars from './Bars.jsx';
// import { scaleLinear } from 'd3-scale'
// import { interpolateLab } from 'd3-interpolate'

export default class GroupBars extends Component {
  constructor(props) {
    super(props)
    this.state={
    }
    // this.colorScale = scaleLinear()
    //   .domain([0, this.props.maxValue])
    //   .range(['#F3E5F5', '#7B1FA2'])
    //   .interpolate(interpolateLab)
  }
  render() {
    const { primaryYAxis,secondoryYAxis, primaryXAxis, secondoryXAxis, svgDimensions,primaryYAxisPadding,margins,chartConfigWithBar,isGroupBar,mainDivId,
            yAxisPrimaryCategories,yAxisSecondaryCategories,globalTooltip,globalTooltipData,showColumnGroupChartTooltip,hideColumnGroupChartTooltip } = this.props
    const { height } = svgDimensions;
    
    var that=this;
    return (
      <g className='columnGroupBar'>
          {
            yAxisPrimaryCategories.length && yAxisPrimaryCategories.map(function(d,index){
                d=(d!=null && typeof(d)=='object') ? d.data : d;
                return <g key={index} transform={"translate(" + margins.left + ","+primaryYAxis.scale(yAxisPrimaryCategories[index])+")"}>
                   {chartConfigWithBar.length && chartConfigWithBar.map(function(d1,indexBar){
                    let isGroupDataHaveNegativeValue=d1.data.filter(function(datum){
                              let oriDatum=datum;  
                              if(datum!=null && typeof(datum)=='object'){
                                oriDatum=datum.data;
                              }
                              return oriDatum<0;
                            }).length;
                    isGroupDataHaveNegativeValue=isGroupDataHaveNegativeValue>0 ? 1 : 0;
                     return <Bars yAxisScale={d1.xAxis==1 ? secondoryXAxis : primaryXAxis } 
                        tooltipConfig={d1.tooltipConfig || {}} 
                         xAxisScale={primaryYAxisPadding} groupIndex={indexBar} mainGroupIndex={index} dataLabels={d1.dataLabels || {}}
                         margins={margins} data={[d1.data[index]]} xAxisData={d1.yAxis==1 ? yAxisSecondaryCategories : yAxisPrimaryCategories} fillColor={d1.fillColor}
                         svgDimensions={svgDimensions} key={'Bar_'+indexBar} isGroupBar={isGroupBar} tooltip={d1.tooltip} tooltipStyle={d1.tooltipStyle || {}} name={d1.name || ''}
                         xAxisCategory={yAxisPrimaryCategories[index]} id={`${that.props.id}_${index}_${indexBar}`} hoverStyle={d1.hoverStyle || {}}
                         tooltipPosition={d1.tooltipPosition || "default"} onColumnBarClick={d1.onColumnBarClick}
                         globalTooltip={globalTooltip} globalTooltipData={globalTooltipData} primaryXAxis={primaryYAxis}
                         mainDivId={mainDivId} showColumnChartTooltip={showColumnGroupChartTooltip} hideColumnChartTooltip={hideColumnGroupChartTooltip} isGroupDataHaveNegativeValue={isGroupDataHaveNegativeValue}>
                        
                         </Bars>
                   })}
                </g>
              })
          }
          { React.Children.count(this.props.children) ? 
            <g className="columnGroupBarChildComponent">
              { React.Children.map(this.props.children,function(child,index){
                  return (<g key={index}  className="columnGroupBarChildComponent">{child}</g>);
                })
              }
            </g> 
            : null
          }  
      </g>
    )
  }
}
